import React from "react";
import { Typography, Container, Box, styled } from "@mui/material";

// Styled component using MUI v5's styled API
const StyledFooter = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(6, 0),
  marginTop: "auto",
}));

const Footer = () => {
  return (
    <StyledFooter component="footer">
      <Container maxWidth="lg">
        <Typography variant="h6" align="center" gutterBottom>
          Salon Booking System
        </Typography>
        <Typography
          variant="subtitle1"
          align="center"
          color="text.secondary" // Updated to MUI v5 color system
          component="p"
        >
          © {new Date().getFullYear()} All rights reserved
        </Typography>
      </Container>
    </StyledFooter>
  );
};

export default Footer;
